import { StyleProvider } from '@ant-design/cssinjs';
import { createCustomTheme } from '@routerfy/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import { useState } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import AppProvider from './context';
import { IConfigStyle } from './interfaces/IConfigStyle';
import Checkout from './pages/Checkout';
import { NotFound } from './pages/NotFound';
import Subscription from './pages/Subscription';
import Success from './pages/Success';

const queryClient = new QueryClient();

function App() {
  const [style, setStyle] = useState<IConfigStyle>({
    primaryColor: '#0AB187',
    secondaryColor: '#0AB187',
    borderColor: '#d9d9d9',
    textColor: '#4B5563',
    bgColor: '#ffffff',
    footerBgColor: '#E5E5E5',
    backgroundColor: '#ffffff',
    backgroundImage: '',
    topBanner: '',
    bottomBanner: '',
    rightBanner: '',
  });

  const theme = createCustomTheme({
    token: {
      ...(style?.primaryColor ? { colorPrimary: style?.primaryColor } : {}),
      ...(style?.bgColor ? { colorBgContainer: style?.bgColor } : {}),
      ...(style?.borderColor ? { colorBorder: style?.borderColor } : {}),
    }
  });

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/t/:id" element={<Checkout modeAs="transaction" />} />
        <Route path="/t/:transactionId/success" element={<Success />} />
        <Route path="/c/:id/success/:transactionId" element={<Success />} />
        <Route path="/c/:id/:salesKey?" element={<Checkout modeAs="checkout" />} />
        <Route path="/s/:id" element={<Subscription />} />
        <Route path="/preview" element={<Checkout modeAs="preview" />} />
        <Route path="*" element={<NotFound />} />
      </>
    )
  );

  return (
    <AppProvider value={{ style, setStyle }}>
      <QueryClientProvider client={queryClient}>
        <StyleProvider layer>
          <ConfigProvider theme={theme}>
            <AntdApp>
              <RouterProvider router={router} />
            </AntdApp>
          </ConfigProvider>
        </StyleProvider>
      </QueryClientProvider>
    </AppProvider>
  );
}

export default App;
